import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_233: DocMigration = {
  maxSchemaVersion: "0.0.233",
  description: "Remove deprecated HOSTED stair system.",
  apply(json: any) {
    const stairSystems = json["stairSystems"];
    if (stairSystems && typeof stairSystems === "object") {
      for (const [id, stairSystem] of Object.entries(stairSystems)) {
        if (typeof stairSystem === "object" && stairSystem !== null && stairSystem["type"] === "HOSTED") {
          delete json["stairSystems"][id];
        }
      }
    }
    return json;
  },
};

export default migration_0_0_233;
